import { render } from "./labels.vue?vue&type=template&id=4e728a28&scoped=true"
import script from "./labels.vue?vue&type=script&lang=js"
export * from "./labels.vue?vue&type=script&lang=js"

import "./labels.vue?vue&type=style&index=0&id=4e728a28&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e728a28"]])

export default __exports__